import React, { useState, useEffect } from 'react';
import {
  FiPackage,
  FiShoppingCart,
  FiClock,
  FiSearch,
  FiDollarSign,
  FiCheckCircle,
  FiTruck,
  FiFlag,
  FiXCircle,
  FiX,
  FiBox,
  FiMapPin,
  FiPlus,
  FiChevronRight,
} from 'react-icons/fi';
import axios from 'axios';
import useWindowSize from 'shared/hooks/useWindowSize';
import { etiquetaTotal } from 'shared/etiquetaUtils';
import { fmtMonto } from 'shared/format';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:8000';

const ESTADO_LABEL = {
  pendiente: 'Pendiente',
  en_revision: 'En Revision',
  aprobado: 'Metodo de Pago',
  esperando_pago: 'Pagar',
  pago_en_verificacion: 'Verificando',
  pagado: 'Pagado',
  armado_cocina: 'Armando',
  armado: 'Armando',
  listo: 'Listo',
  despachado: 'Despachado',
  en_camino: 'En Camino',
  llegada: 'Llegada',
  entregado: 'Entregado',
  rechazado: 'Rechazado',
  cancelado: 'Cancelado',
  credito_pagado: 'Credito pagado',
};

const ESTADO_ICON = {
  pendiente: FiClock,
  en_revision: FiSearch,
  aprobado: FiDollarSign,
  esperando_pago: FiDollarSign,
  pago_en_verificacion: FiSearch,
  pagado: FiCheckCircle,
  armado_cocina: FiPackage,
  armado: FiPackage,
  listo: FiBox,
  despachado: FiTruck,
  en_camino: FiTruck,
  llegada: FiMapPin,
  entregado: FiFlag,
  rechazado: FiXCircle,
  cancelado: FiXCircle,
  credito_pagado: FiCheckCircle,
};

const ESTADO_COLOR = {
  pendiente: '#FF9500',
  en_revision: '#FF9500',
  aprobado: 'var(--color-secondary)',
  esperando_pago: '#FF9500',
  pago_en_verificacion: '#FF9500',
  pagado: 'var(--color-success)',
  armado_cocina: '#ff6d00',
  armado: '#ff6d00',
  listo: 'var(--color-secondary)',
  despachado: '#00bcd4',
  en_camino: '#00bcd4',
  llegada: '#009688',
  entregado: 'var(--color-success)',
  rechazado: 'var(--color-danger)',
  cancelado: '#9aa0a6',
  credito_pagado: 'var(--color-success)',
};

function ClienteInicio({
  pedidosActivos,
  pedidosHistorial,
  cargando,
  onNewOrder,
  abriendoPedido,
  onVerPedido,
  permiteNuevoPedido = true,
  schemaName,
  onVerNuevos,
}) {
  const { width } = useWindowSize();
  const isDesktop = width >= 768;
  const [pedidoModal, setPedidoModal] = useState(null);
  const [tagNuevo, setTagNuevo] = useState(null);

  useEffect(() => {
    if (!schemaName) return;
    axios
      .get(`${API_URL}/catalogo/tags?schema_name=${schemaName}`)
      .then((res) => {
        if (res.data.status !== 'success') return;
        const tags = res.data.data || [];
        const normalizar = (s) =>
          (s || '')
            .toLowerCase()
            .normalize('NFD')
            .replace(/[\u0300-\u036f]/g, '')
            .replace(/[^a-z0-9 ]/g, '')
            .trim();
        const encontrado = tags.find((t) => {
          const n = normalizar(t.nombre);
          return ['recien llegado', 'recien', 'nuevo', 'novedades', 'novedad', 'nuevos productos', 'nuevo producto', 'llegado'].includes(n);
        });
        setTagNuevo(encontrado || null);
      })
      .catch(() => {});
  }, [schemaName]);


  const formatFecha = (str) => {
    if (!str) return '';
    try {
      return new Date(str).toLocaleDateString('es-VE', {
        day: 'numeric',
        month: 'short',
        year: 'numeric',
      });
    } catch {
      return '';
    }
  };

  const formatHora = (str) => {
    if (!str) return '';
    try {
      return new Date(str).toLocaleTimeString('es-VE', { hour: '2-digit', minute: '2-digit' });
    } catch {
      return '';
    }
  };

  const parseProductos = (p) => {
    try {
      return typeof p.productos === 'string' ? JSON.parse(p.productos) : p.productos || [];
    } catch {
      return [];
    }
  };

  const formatTotal = (p) => {
    if (!p) return '$0.00';
    const t = typeof p.total === 'number' ? p.total : parseFloat(p.total || 0);
    if (t > 0) return `$${fmtMonto(t + (parseFloat(p.costo_envio) || 0))}`;
    const prods = Array.isArray(p.productos) ? p.productos : [];
    if (prods.length === 0) return '$0.00';
    const calcTotal = prods.reduce((s, pr) => {
      const precio = parseFloat(pr.precio || 0);
      const cant = pr.cantidad || 1;
      const base = pr.pesable ? precio * cant / 1000 : precio * cant;
      const etiqExtra = pr.etiquetas_extra || (pr.etiquetas || []).reduce((t, e) => t + (e.precio || 0), 0);
      return s + base + etiqExtra;
    }, 0);
    return `$${fmtMonto(calcTotal + (parseFloat(p.costo_envio) || 0))}`;
  };

  const contarItems = (p) => {
    try {
      const prod = typeof p.productos === 'string' ? JSON.parse(p.productos) : p.productos || [];
      return Array.isArray(prod) ? prod.length : 0;
    } catch {
      return 0;
    }
  };
  return (
    <div
      style={{
        ...T.container,
        padding: isDesktop ? '24px' : '16px',
        display: isDesktop ? 'grid' : 'flex',
        gridTemplateColumns: isDesktop ? '1fr 1fr' : undefined,
        gap: isDesktop ? '20px' : '16px',
        flexDirection: isDesktop ? undefined : 'column',
      }}
    >
      {tagNuevo && onVerNuevos && (
        <div
          onClick={onVerNuevos}
          style={{
            gridColumn: isDesktop ? '1 / -1' : undefined,
            display: 'flex',
            alignItems: 'center',
            gap: '12px',
            padding: '16px 18px',
            borderRadius: '14px',
            background: 'linear-gradient(120deg, #c5221f 0%, #ea4335 55%, #ff6d00 100%)',
            color: '#fff',
            cursor: 'pointer',
            boxShadow: '0 6px 20px rgba(197,34,31,0.35)',
            overflow: 'hidden',
            position: 'relative',
            marginBottom: isDesktop ? '4px' : '0',
          }}
        >
          <span
            style={{
              position: 'absolute',
              top: '-14px',
              right: '-10px',
              fontSize: '64px',
              opacity: 0.18,
              transform: 'rotate(-12deg)',
              pointerEvents: 'none',
            }}
          >
            ✨
          </span>
          <div
            style={{
              width: '42px',
              height: '42px',
              borderRadius: '12px',
              background: 'rgba(255,255,255,0.2)',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              flexShrink: 0,
              fontSize: '22px',
            }}
          >
            {tagNuevo.icono ? <span>{tagNuevo.icono}</span> : '✨'}
          </div>
          <div style={{ flex: 1, minWidth: 0 }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
              <span style={{ fontSize: '10px', fontWeight: 800, letterSpacing: '1px', textTransform: 'uppercase', background: 'rgba(255,255,255,0.25)', padding: '2px 8px', borderRadius: '10px' }}>
                Nuevo
              </span>
            </div>
            <div style={{ fontSize: '15px', fontWeight: 800, lineHeight: 1.25, marginTop: '3px' }}>
              ¡Recién llegado! Descubre lo último en nuestro catálogo
            </div>
            <div style={{ fontSize: '12px', fontWeight: 500, opacity: 0.9, marginTop: '2px' }}>
              {tagNuevo.total_productos} producto{tagNuevo.total_productos === 1 ? '' : 's'} nuevos esperándote
            </div>
          </div>
          <button
            onClick={(e) => { e.stopPropagation(); onVerNuevos(); }}
            style={{
              display: 'inline-flex',
              alignItems: 'center',
              gap: '6px',
              padding: '9px 16px',
              borderRadius: '10px',
              border: 'none',
              background: '#fff',
              color: '#c5221f',
              fontSize: '13px',
              fontWeight: 800,
              cursor: 'pointer',
              fontFamily: 'inherit',
              whiteSpace: 'nowrap',
              flexShrink: 0,
            }}
          >
            Ver ahora
            <FiChevronRight size={15} />
          </button>
        </div>
      )}
      {cargando ? (
        <div style={T.loading}>
          <div style={{ display: 'flex', gap: '6px' }}>
            <span style={T.loadDot} />
            <span style={{ ...T.loadDot, animationDelay: '0.15s' }} />
            <span style={{ ...T.loadDot, animationDelay: '0.3s' }} />
          </div>
        </div>
      ) : (
        <>
          <div style={{ gridColumn: isDesktop ? '1 / -1' : undefined }}>
            <div style={T.sectionHeader}>
              <h3 style={T.sectionTitle}>
                <FiPackage size={16} strokeWidth={2} style={{ marginRight: '8px' }} />
                {pedidosActivos.length > 0
                  ? `Tus pedidos activos (${pedidosActivos.length})`
                  : 'Sin pedidos activos'}
              </h3>
            </div>

            {pedidosActivos.length > 0 ? (
              <div
                style={{
                  display: 'grid',
                  gridTemplateColumns: isDesktop ? 'repeat(2, 1fr)' : '1fr',
                  gap: '12px',
                }}
              >
                {pedidosActivos.map((p) => {
                  const Icon = ESTADO_ICON[p.estado] || FiPackage;
                  return (
                    <div
                      key={p.id}
                      style={T.orderCard}
                      onClick={() => onVerPedido(p.id)}
                    >
                      <div
                        style={{
                          display: 'flex',
                          justifyContent: 'space-between',
                          alignItems: 'flex-start',
                        }}
                      >
                        <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                          <div
                            style={{
                              ...T.histIcon,
                              backgroundColor: (ESTADO_COLOR[p.estado] || 'var(--color-secondary)') + '18',
                            }}
                          >
                            <Icon
                              size={18}
                              color={ESTADO_COLOR[p.estado] || 'var(--color-secondary)'}
                            />
                          </div>
                          <div>
                            <div style={T.orderTitle}>Pedido #{p.id}</div>
                            <div style={T.orderDate}>
                              {formatFecha(p.fechapedido)} · {formatHora(p.fechapedido)}
                            </div>
                          </div>
                        </div>
                        <span
                          style={{
                            ...T.orderBadge,
                            color: ESTADO_COLOR[p.estado] || 'var(--color-text-secondary)',
                            backgroundColor:
                              (ESTADO_COLOR[p.estado] || 'var(--color-text-secondary)') + '18',
                          }}
                        >
                          {ESTADO_LABEL[p.estado] || p.estado}
                        </span>
                      </div>
                      <div style={T.orderDivider} />
                      <div
                        style={{
                          display: 'flex',
                          justifyContent: 'space-between',
                          alignItems: 'center',
                        }}
                      >
                        <span style={T.orderAmount}>{formatTotal(p)}</span>
                        <span style={T.orderItemCount}>
                          {contarItems(p)} {contarItems(p) === 1 ? 'artículo' : 'artículos'}
                        </span>
                      </div>
                    </div>
                  );
                })}
              </div>
            ) : (
              <div style={T.heroEmpty}>
                <div style={{ fontSize: '28px', marginBottom: '10px' }}>
                  <FiPackage size={32} color="rgba(255,255,255,0.8)" />
                </div>
                <div
                  style={{
                    fontSize: '17px',
                    fontWeight: 700,
                    color: 'var(--color-surface)',
                    marginBottom: '4px',
                  }}
                >
                  Sin pedidos activos
                </div>
                <div style={{ fontSize: '13px', color: 'rgba(255,255,255,0.7)' }}>
                  Arma un nuevo pedido desde el catálogo
                </div>
              </div>
            )}
          </div>


          {pedidosHistorial.length > 0 && (
            <div style={{ ...T.historySection, gridColumn: isDesktop ? '1' : undefined }}>
              <div style={T.sectionHeader}>
                <h3 style={T.sectionTitle}>
                  <FiPackage size={16} strokeWidth={2} style={{ marginRight: '8px' }} />
                  Historial reciente
                </h3>
              </div>
              {pedidosHistorial.slice(0, 3).map((p) => {
                const Icon = ESTADO_ICON[p.estado] || FiPackage;
                return (
                  <div key={p.id} style={T.historyCard} onClick={() => setPedidoModal(p)}>
                    <div style={T.histIcon}>
                      <Icon
                        size={16}
                        color={ESTADO_COLOR[p.estado] || 'var(--color-text-secondary)'}
                      />
                    </div>
                    <div style={{ flex: 1 }}>
                      <div
                        style={{
                          display: 'flex',
                          justifyContent: 'space-between',
                          alignItems: 'center',
                        }}
                      >
                        <span
                          style={{
                            fontSize: '14px',
                            fontWeight: 600,
                            color: 'var(--color-primary)',
                          }}
                        >
                          Pedido
                        </span>
                        <span
                          style={{
                            fontSize: '11px',
                            fontWeight: 600,
                            color:
                              p.estado === 'entregado'
                                ? 'var(--color-success)'
                                : p.estado === 'rechazado'
                                  ? 'var(--color-danger)'
                                  : 'var(--color-text-secondary)',
                            backgroundColor:
                              p.estado === 'entregado'
                                ? 'rgba(0,230,118,0.1)'
                                : p.estado === 'rechazado'
                                  ? 'rgba(255,59,48,0.08)'
                                  : 'var(--color-bg)',
                            padding: '3px 10px',
                            borderRadius: '10px',
                          }}
                        >
                          {ESTADO_LABEL[p.estado] || p.estado}
                        </span>
                      </div>
                      <div
                        style={{
                          fontSize: '12px',
                          color: 'var(--color-text-secondary)',
                          marginTop: '4px',
                        }}
                      >
                        {contarItems(p)} artículos · {formatTotal(p)} · {formatFecha(p.fechapedido)}
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>
          )}

          <div
            style={{
              ...T.ctaCard,
              gridColumn: isDesktop ? '2' : undefined,
              gridRow: isDesktop ? '2' : undefined,
            }}
          >
            <div style={{ fontSize: '28px', marginBottom: '8px' }}>
              <FiShoppingCart size={32} color="var(--color-secondary)" />
            </div>
            <div
              style={{
                fontSize: '17px',
                fontWeight: 700,
                color: 'var(--color-primary)',
                marginBottom: '4px',
              }}
            >
              Armar un pedido nuevo
            </div>
            <div
              style={{
                fontSize: '13px',
                color: 'var(--color-text-secondary)',
                marginBottom: '18px',
              }}
            >
              {permiteNuevoPedido
                ? 'Puedes tener varios pedidos en curso al mismo tiempo'
                : 'Termina tu pedido actual antes de iniciar uno nuevo'}
            </div>
            <button
              onClick={onNewOrder}
              disabled={abriendoPedido || !permiteNuevoPedido}
              style={{
                ...T.ctaBtn,
                opacity: abriendoPedido || !permiteNuevoPedido ? 0.5 : 1,
                cursor: abriendoPedido || !permiteNuevoPedido ? 'not-allowed' : 'pointer',
              }}
            >
              <FiPlus size={16} style={{ marginRight: '8px' }} />
              {abriendoPedido ? 'Abriendo...' : 'Nuevo pedido'}
            </button>
          </div>
        </>
      )}

      {pedidoModal && (
        <div onClick={() => setPedidoModal(null)} style={M.overlay}>
          <div onClick={(e) => e.stopPropagation()} style={M.modal}>
            <div style={M.header}>
              <div>
                <span style={M.pedidoId}>Pedido</span>
                <span
                  style={{
                    ...M.estadoBadge,
                    color: ESTADO_COLOR[pedidoModal.estado] || 'var(--color-text-secondary)',
                    backgroundColor:
                      (ESTADO_COLOR[pedidoModal.estado] || 'var(--color-text-secondary)') + '18',
                  }}
                >
                  {ESTADO_LABEL[pedidoModal.estado] || pedidoModal.estado}
                </span>
              </div>
              <button onClick={() => setPedidoModal(null)} style={M.closeBtn}>
                <FiX size={20} />
              </button>
            </div>

            <div style={M.fechaRow}>
              <FiClock size={14} color="var(--color-text-secondary)" />
              <span style={M.fechaText}>
                {formatFecha(pedidoModal.fechapedido)} · {formatHora(pedidoModal.fechapedido)}
              </span>
            </div>

            <div style={M.divider} />

            <div style={M.productosList}>
              {parseProductos(pedidoModal).length === 0 ? (
                <span style={M.emptyProducts}>Sin productos registrados</span>
              ) : (
                parseProductos(pedidoModal).map((prod, i) => {
                  const cantidad = prod.cantidad || 1;
                  const precio = parseFloat(prod.precio || 0);
                  const pesable = prod.pesable || false;
                  const subtotal = (pesable ? (precio * cantidad) / 1000 : precio * cantidad) + etiquetaTotal(prod);
                  return (
                    <div key={i} style={M.productRow}>
                      <div style={{ flex: 1, minWidth: 0 }}>
                        <div style={M.productName}>{prod.nombre || prod.codigo || 'Producto'}</div>
                        <div style={M.productDetail}>
                          {pesable ? `${(cantidad / 1000).toFixed(2)} kg` : `${cantidad} und`} x $
                          {fmtMonto(precio)}
                        </div>
                        {(prod.etiquetas_extra > 0 || (prod.etiquetas || []).length > 0) && (
                          <div style={{ fontSize: '10px', color: '#ff6d00', marginTop: '2px' }}>
                            {(prod.etiquetas || []).map((et, ei) => (
                              <span key={et.id || ei}>
                                {et.nombre}{et.precio > 0 ? ` +$${fmtMonto(et.precio)}` : ''}
                                {ei < (prod.etiquetas || []).length - 1 ? ', ' : ''}
                              </span>
                            ))}
                          </div>
                        )}
                        {prod.combo_id &&
                          Array.isArray(prod.componentes) &&
                          prod.componentes.length > 0 && (
                            <div style={{ marginTop: '3px', paddingLeft: '2px' }}>
                              {prod.componentes.map((comp, ci) => {
                                const compEtiq = Array.isArray(comp.etiquetas) ? comp.etiquetas : [];
                                return (
                                  <div
                                    key={ci}
                                    style={{
                                      display: 'flex',
                                      alignItems: 'center',
                                      gap: '4px',
                                      fontSize: '10px',
                                      padding: '1px 0',
                                    }}
                                  >
                                    <span
                                      style={{
                                        display: 'inline-block',
                                        width: 4,
                                        height: 4,
                                        borderRadius: '50%',
                                        backgroundColor: '#f0b400',
                                        flexShrink: 0,
                                      }}
                                    />
                                    <span style={{ color: 'var(--color-text-secondary)' }}>
                                      {comp.nombre}
                                    </span>
                                    {compEtiq.length > 0 && (
                                      <span style={{ color: 'var(--color-text-muted)' }}>
                                        ({compEtiq.map((e) => e.nombre).join(', ')})
                                      </span>
                                    )}
                                  </div>
                                );
                              })}
                            </div>
                          )}
                      </div>
                      <span style={M.productSubtotal}>${fmtMonto(subtotal)}</span>
                    </div>
                  );
                })
              )}
            </div>

            <div style={M.divider} />

            {(parseFloat(pedidoModal.costo_envio) || 0) > 0 && (
              <div
                style={{
                  display: 'flex',
                  justifyContent: 'space-between',
                  padding: '4px 0',
                  fontSize: '13px',
                  color: 'var(--color-text-secondary)',
                }}
              >
                <span>Costo de envío</span>
                <span style={{ fontWeight: 600 }}>
                  ${fmtMonto(pedidoModal.costo_envio)}
                </span>
              </div>
            )}

            <div style={M.totalRow}>
              <span style={M.totalLabel}>Total</span>
              <span style={M.totalAmount}>
                $
                {fmtMonto((typeof pedidoModal.total === 'number'
                  ? pedidoModal.total
                  : parseFloat(pedidoModal.total || 0)
                ) + (parseFloat(pedidoModal.costo_envio) || 0))}
              </span>
            </div>
          </div>
        </div>
      )}

      <style>{`@keyframes loadingDot { 0%,80%,100%{opacity:0.3;transform:scale(0.8)}40%{opacity:1;transform:scale(1)} }`}</style>
    </div>
  );
}

const T = {
  container: {
    padding: '16px',
    display: 'flex',
    flexDirection: 'column',
    gap: '16px',
    paddingBottom: '16px',
  },
  loading: { display: 'flex', justifyContent: 'center', padding: '80px 0' },
  loadDot: {
    width: '8px',
    height: '8px',
    borderRadius: '50%',
    backgroundColor: 'var(--color-secondary)',
    animation: 'loadingDot 1.2s infinite ease-in-out',
  },
  heroCard: {
    background: 'linear-gradient(135deg, var(--color-secondary), var(--color-primary))',
    borderRadius: '24px',
    padding: '20px',
    color: 'var(--color-surface)',
    boxShadow: '0 8px 32px rgba(11,26,74,0.2)',
    cursor: 'pointer',
  },
  heroHeader: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'flex-start',
    marginBottom: '24px',
  },
  heroLabel: {
    fontSize: '12px',
    fontWeight: 500,
    opacity: 0.7,
    marginBottom: '4px',
    textTransform: 'uppercase',
    letterSpacing: '1px',
  },
  heroTitle: { fontSize: '16px', fontWeight: 700 },
  heroStatus: {
    display: 'flex',
    alignItems: 'center',
    backgroundColor: 'rgba(255,255,255,0.12)',
    padding: '6px 12px',
    borderRadius: '20px',
    fontSize: '12px',
    fontWeight: 600,
  },
  heroStatusDot: {
    width: '7px',
    height: '7px',
    borderRadius: '50%',
    backgroundColor: 'var(--color-success)',
    marginRight: '6px',
    boxShadow: '0 0 8px rgba(0,230,118,0.5)',
  },
  heroBody: { display: 'flex', justifyContent: 'space-between', alignItems: 'flex-end' },
  heroAmount: { fontSize: '36px', fontWeight: 900, lineHeight: 1, marginBottom: '6px' },
  heroItemCount: { fontSize: '13px', opacity: 0.7 },
  heroAction: {
    background: 'rgba(255,255,255,0.15)',
    border: '1px solid rgba(255,255,255,0.2)',
    borderRadius: '12px',
    color: 'var(--color-surface)',
    padding: '8px 14px',
    fontSize: '12px',
    fontWeight: 600,
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
    whiteSpace: 'nowrap',
  },
  heroEmpty: {
    background: 'linear-gradient(135deg, var(--color-primary), var(--color-secondary))',
    borderRadius: '24px',
    padding: '32px 20px',
    textAlign: 'center',
    color: 'var(--color-surface)',
  },
  activesSection: {
    backgroundColor: 'var(--color-surface)',
    borderRadius: '20px',
    padding: '16px',
    boxShadow: '0 1px 3px rgba(11,26,74,0.04)',
  },
  historySection: {
    backgroundColor: 'var(--color-surface)',
    borderRadius: '20px',
    padding: '16px',
    boxShadow: '0 1px 3px rgba(11,26,74,0.04)',
  },
  sectionHeader: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: '12px',
  },
  sectionTitle: {
    margin: 0,
    fontSize: '15px',
    fontWeight: 700,
    color: 'var(--color-primary)',
    display: 'flex',
    alignItems: 'center',
  },
  verTodos: {
    backgroundColor: 'transparent',
    border: 'none',
    color: 'var(--color-secondary)',
    fontSize: '13px',
    fontWeight: 600,
    cursor: 'pointer',
  },
  historyCard: {
    display: 'flex',
    alignItems: 'center',
    gap: '12px',
    padding: '12px 0',
    borderBottom: '1px solid var(--color-bg-hover)',
    cursor: 'pointer',
  },
  orderCard: {
    backgroundColor: 'var(--color-surface)',
    borderRadius: '16px',
    padding: '14px',
    boxShadow: '0 1px 3px rgba(11,26,74,0.06)',
    cursor: 'pointer',
    border: '1px solid var(--color-bg-hover)',
  },
  orderTitle: { fontSize: '15px', fontWeight: 700, color: 'var(--color-primary)' },
  orderDate: { fontSize: '11px', color: 'var(--color-text-muted)', marginTop: '2px' },
  orderBadge: {
    fontSize: '11px',
    fontWeight: 600,
    padding: '4px 10px',
    borderRadius: '10px',
    whiteSpace: 'nowrap',
  },
  orderDivider: { height: '1px', backgroundColor: 'var(--color-bg-hover)', margin: '12px 0' },
  orderAmount: { fontSize: '20px', fontWeight: 800, color: 'var(--color-secondary)' },
  orderItemCount: { fontSize: '12px', color: 'var(--color-text-secondary)', fontWeight: 600 },
  histIcon: {
    width: '36px',
    height: '36px',
    borderRadius: '10px',
    backgroundColor: 'var(--color-bg)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontSize: '16px',
    flexShrink: 0,
  },
  ctaCard: {
    backgroundColor: 'var(--color-surface)',
    borderRadius: '20px',
    padding: '24px 16px',
    textAlign: 'center',
    boxShadow: '0 1px 3px rgba(11,26,74,0.04)',
  },
  ctaBtn: {
    padding: '14px 32px',
    borderRadius: '16px',
    border: 'none',
    backgroundColor: 'var(--color-secondary)',
    color: 'var(--color-surface)',
    fontSize: '15px',
    fontWeight: 700,
    cursor: 'pointer',
    display: 'inline-flex',
    alignItems: 'center',
    boxShadow: '0 4px 16px rgba(41,82,204,0.25)',
  },
  downloadCard: {
    backgroundColor: 'var(--color-surface)',
    borderRadius: '20px',
    padding: '18px',
    boxShadow: '0 2px 12px rgba(11,26,74,0.06), 0 0 0 1px rgba(11,26,74,0.04)',
    position: 'relative',
    overflow: 'hidden',
  },
  downloadTop: { display: 'flex', gap: '16px', alignItems: 'center' },
  phoneVisual: { flexShrink: 0 },
  phoneFrame: {
    width: '72px',
    height: '130px',
    borderRadius: '14px',
    backgroundColor: 'var(--color-primary)',
    padding: '6px',
    boxShadow: '0 8px 24px rgba(11,26,74,0.25), inset 0 0 0 2px rgba(255,255,255,0.1)',
  },
  phoneNotch: {
    width: '28px',
    height: '4px',
    borderRadius: '3px',
    backgroundColor: 'rgba(255,255,255,0.2)',
    margin: '0 auto 6px',
  },
  phoneScreen: {
    height: '92px',
    borderRadius: '8px',
    backgroundColor: 'var(--color-bg)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  phoneLogo: {
    width: '44px',
    height: '44px',
    borderRadius: '12px',
    backgroundColor: 'var(--color-primary)',
    color: 'var(--color-surface)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontWeight: 800,
    fontSize: '16px',
    letterSpacing: '-0.5px',
    boxShadow: '0 4px 16px rgba(11,26,74,0.3)',
  },
  downloadInfo: { flex: 1, minWidth: 0 },
  downloadTitle: {
    fontSize: '16px',
    fontWeight: 700,
    color: 'var(--color-primary)',
    marginBottom: '2px',
    letterSpacing: '-0.3px',
  },
  downloadSubtitle: {
    fontSize: '13px',
    fontWeight: 400,
    color: 'var(--color-text-secondary)',
    marginBottom: '12px',
  },
  downloadFeatures: { display: 'flex', flexDirection: 'column', gap: '8px', marginBottom: '14px' },
  featureItem: {
    display: 'flex',
    alignItems: 'center',
    gap: '10px',
    fontSize: '13px',
    fontWeight: 500,
    color: '#445577',
  },
  downloadBtn: {
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
    padding: '11px 22px',
    borderRadius: '14px',
    border: 'none',
    backgroundColor: 'var(--color-secondary)',
    color: 'var(--color-surface)',
    fontSize: '14px',
    fontWeight: 700,
    cursor: 'pointer',
    boxShadow: '0 4px 16px rgba(41,82,204,0.25)',
    width: '100%',
    justifyContent: 'center',
  },
  downloadCardInstalada: {
    backgroundColor: '#ECFDF5',
    borderRadius: '20px',
    padding: '18px',
    boxShadow: '0 2px 12px rgba(5,150,105,0.08), 0 0 0 1px rgba(5,150,105,0.12)',
    position: 'relative',
    overflow: 'hidden',
  },
  phoneLogoCheck: {
    width: '44px',
    height: '44px',
    borderRadius: '12px',
    backgroundColor: '#059669',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  downloadHint: {
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
    marginTop: '16px',
    paddingTop: '16px',
    borderTop: '1px solid var(--color-bg-hover)',
  },
};

const M = {
  overlay: {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: 'rgba(0,0,0,0.5)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    zIndex: 2000,
    padding: '20px',
  },
  modal: {
    backgroundColor: 'var(--color-surface)',
    borderRadius: '20px',
    padding: '24px',
    width: '100%',
    maxWidth: '420px',
    maxHeight: '80vh',
    overflowY: 'auto',
    boxShadow: '0 16px 48px rgba(0,0,0,0.2)',
  },
  header: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'flex-start',
    marginBottom: '16px',
  },
  pedidoId: {
    fontSize: '18px',
    fontWeight: 700,
    color: 'var(--color-primary)',
    marginRight: '10px',
  },
  estadoBadge: {
    fontSize: '12px',
    fontWeight: 600,
    padding: '4px 10px',
    borderRadius: '10px',
    display: 'inline-block',
  },
  closeBtn: {
    background: 'var(--color-bg)',
    border: 'none',
    borderRadius: '50%',
    width: '36px',
    height: '36px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    cursor: 'pointer',
    color: 'var(--color-text-secondary)',
    flexShrink: 0,
  },
  fechaRow: { display: 'flex', alignItems: 'center', gap: '8px', marginBottom: '16px' },
  fechaText: { fontSize: '13px', color: 'var(--color-text-secondary)' },
  divider: { height: '1px', backgroundColor: 'var(--color-bg-hover)', margin: '12px 0' },
  productosList: { maxHeight: '40vh', overflowY: 'auto' },
  emptyProducts: { fontSize: '13px', color: 'var(--color-text-muted)', fontStyle: 'italic' },
  productRow: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'flex-start',
    padding: '8px 0',
    gap: '12px',
  },
  productName: {
    fontSize: '13px',
    fontWeight: 600,
    color: 'var(--color-primary)',
    lineHeight: 1.3,
  },
  productDetail: { fontSize: '12px', color: 'var(--color-text-secondary)', marginTop: '2px' },
  productSubtotal: {
    fontSize: '13px',
    fontWeight: 600,
    color: 'var(--color-secondary)',
    whiteSpace: 'nowrap',
  },
  totalRow: { display: 'flex', justifyContent: 'space-between', alignItems: 'center' },
  totalLabel: { fontSize: '16px', fontWeight: 700, color: 'var(--color-primary)' },
  totalAmount: { fontSize: '20px', fontWeight: 800, color: 'var(--color-secondary)' },
};

export default ClienteInicio;
